// extracted by mini-css-extract-plugin
module.exports = {"inputs":"style_inputs__2Vd_e","controls":"style_controls__3UZyN","actions":"style_actions__3H4uV","input":"style_input__2Ky8A"};